import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../suguyaku.constants';

@Component({
  selector: 'app-suguyaku-change-password-sent',
  templateUrl: './suguyaku-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './suguyaku-change-password-sent.component.css',
  ],
})
export class SuguyakuChangePasswordSentComponent implements OnInit {
  email: string;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void { }
}
